import { TitleComponent, CardComponent, TableComponent, PortalComponent, ModalComponent,DropDownMenuComponent} from "../../../components/pages"
import { api, apiConfig } from "../../../util/api";
import { useState, useEffect} from "react";
import { useGetApiWs } from "../../../hooks";
import {Menu} from '@headlessui/react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPowerOff } from "@fortawesome/free-solid-svg-icons";
import AssignCategories from './assignCategories';
import AssignChannels from './assignChannels';
import AssignCities from './assignCities';
import AssignAttributes from './assignAttributes';

const Customer = () => {
    const urlCustomer = useGetApiWs('admin', 'entity', 'company-get');

    const [assignAttributes, setAssignAttributes] = useState(false);
    const [assignCategories,setAssignCategories] = useState(false);
    const [assignChannels,setAssignChannels] = useState(false);
    const [assignCities,setAssignCities] = useState(false);
    const [companySelected, setCompanySelected] = useState(null);
    const [customers, setCustomers] = useState([]);

    const openAssignAttributesModal = (companyId) => { setCompanySelected(companyId); setAssignAttributes(true); }
    const closeAssignAttributesModal = () => { setAssignAttributes(false); }
    const openAssignCategoriesModal = (companyId)=>{setCompanySelected(companyId);setAssignCategories(true);}
    const closeAssignCategoriesModal = ()=>{setAssignCategories(false);}
    const openAssignChannelsModal = (companyId)=>{setCompanySelected(companyId);setAssignChannels(true);}
    const closeAssignChannelsModal = ()=>{setAssignChannels(false)}
    const openAssignCitiesModal = (companyId)=>{setCompanySelected(companyId);setAssignCities(true);}
    const closeAssignCitiesModal = ()=>{setAssignCities(false);}

    const modalAssignAttributes = assignAttributes ? (<AssignAttributes closeModal={closeAssignAttributesModal} companyId={companySelected} ></AssignAttributes>) : null;
    const modalAssignCategories = assignCategories ? (<AssignCategories closeModal={closeAssignCategoriesModal} companyId={companySelected}></AssignCategories>):null;
    const modalAssignCities = assignCities ? (<AssignCities closeModal={closeAssignCitiesModal} companyId={companySelected}></AssignCities>):null;
    const modalAssignChannels = assignChannels ? (<AssignChannels closeModal={closeAssignChannelsModal} companyId={companySelected}></AssignChannels>):null;

    const tbColumns = [
        { name: 'ID', selector: row => row.company_id },
        { name: 'CODIGO', selector: row => row.code },
        { name: 'DESCRIPCION', selector: row => row.description },
        { name: 'OPCIONES', button: true, cell: row => <BtnOpts companyId={row.company_id}></BtnOpts>, allowOverflow: false, style: { position: 'relative', overflow: 'visible' } },
    ];

    const BtnOpts = (props) => {        
        const options = [
            ['Asignar Categorías',()=>{openAssignCategoriesModal(props.companyId)}],
            ['Asignar Canales',()=>{openAssignChannelsModal(props.companyId)}],
            ['Asignar Ciudades',()=>{openAssignCitiesModal(props.companyId)}],
            ['Asignar Atributos',()=>{openAssignAttributesModal(props.companyId)}]
        ]
        
        return (
            <DropDownMenuComponent>
                { 
                    options.map(([title,func],i)=>(
                        <Menu.Item key={i}>                    
                            <button onClick={func} className={`btn-itemDropDown`}>{title}</button>                
                        </Menu.Item>
                    ))
                }
            </DropDownMenuComponent>
            
        )
    }
    
    const fetchCustomers = async () => {
        const cust = await api().post(urlCustomer, { company_type_code: 'CM-CUST' }, apiConfig());
        var options = cust.data.response
        setCustomers(options);
    }


    useEffect(() => {
        fetchCustomers();
    }, [])

    return (
        <div>
            <TitleComponent title="CLIENTE ADMINISTRACION" />
            <CardComponent header={<h4>Cliente administracion</h4>}>
                <TableComponent keyField="work_order_id" columns={tbColumns} data={customers} highlightOnHover={true} />
            </CardComponent>
            {modalAssignAttributes}
            {modalAssignCategories}
            {modalAssignCities}
            {modalAssignChannels}
        </div >
    )
}
export default Customer